//Company form data
export const formData = (
  parentCompanyListOption,
  cityOption,
  values,
  onboardingTitle,
  edit,
  taxOptions = [],
  billToSelfLabel,
  billToCompanyLabel,
) => {
  return {
    [`${onboardingTitle}`]: [
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Company Name",
        required: true,
        type: "companyName",
        name: "name",
        label: "Company name",
        star: "*",
      },
      {
        fileUpload: true,
        required: false,
        gridSize: 6,
        name: "logo",
        label: "Upload Logo",
        placeholder: "Upload Logo",
      },
      {
        singleAutoComplete: true,
        gridSize: 6,
        placeholder: "Choose Parent Company Name",
        name: "parentCompanyId",
        label: "Parent Company Name",
        optionData: parentCompanyListOption || [],
        fieldDisabled: edit ? true : false,
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Company Address",
        required: true,
        type: "text",
        name: "address",
        label: "Address",
      },
      {
        options: true,
        required: true,
        gridSize: 6,
        placeholder: "Choose a City",
        type: "text",
        name: "cityId",
        label: "City",
        menuOptions: cityOption,
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Pincode",
        required: true,
        type: "number",
        name: "pinCode",
        label: "Pin Code",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Company PAN",
        className: "textCapital",
        required: true,
        type: "text",
        name: "panNumber",
        label: "Company PAN",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Email ID",
        required: false,
        type: "email",
        name: "email",
        label: "Email ID",
      },
      {
        textField: true,
        gridSize: 6,
        countrycode: true,
        placeholder: "Enter Phone Number",
        required: false,
        type: "number",
        name: "phoneNumber",
        label: "Phone Number",
      },
      {
        emailDomain: true,
        gridSize: 6,
        name: "allowedDomain",
      },
      {
        emailDomainAddBtn: true,
        gridSize: 12,
        name: "allowedDomainAddBtn",
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
      // NEW: Section Heading for OTP Configuration
      {
        sectionHeading: true,
        gridSize: 12,
        label: "Start and End OTP Configuration",
        className: "otp-section-heading",
      },
      {
        name: "tripOtpOverrideEnabled",
        label: "",
        checkbox: true,
        gridSize: 4,
        required: false,
        subItems: [
          {
            name: "tripOtpOverrideEnabled",
            checkboxLablel: "Enable Trip-Level OTP Override",
          },
        ],
      },
      {
        name: "startOtpRequired",
        label: "",
        checkbox: true,
        gridSize: 4,
        required: false,
        subItems: [
          {
            name: "startOtpRequired",
            checkboxLablel: "Secure Trip Start with OTP",
          },
        ],
      },
      {
        name: "endOtpRequired",
        label: "",
        checkbox: true,
        gridSize: 4,
        required: false,
        subItems: [
          {
            name: "endOtpRequired",
            checkboxLablel: "Secure Trip End with OTP",
          },
        ],
      },

      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
    "Contract Details": [
      {
        datePicker: true,
        disablePast: true,
        required: true,
        gridSize: 6,
        placeholder: "",
        type: "date",
        name: "chooseDate",
        label: "Contract Date",
      },
      {
        dateRangePicker: true,
        disablePastEndDate: true,
        required: true,
        gridSize: 6,
        placeholder: "",
        type: "",
        name: "tenure",
        label: "Tenure",
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
    "Additional Info": [
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Bill To Self Label",
        required: false,
        type: "text",
        name: "billToSelfLabel",
        label: "Bill To Self Label",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Bill To Company Label",
        required: false,
        type: "text",
        name: "billToCompanyLabel",
        label: "Bill To Company Label",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "",
        required: false,
        type: "time",
        name: "nightAllowanceStart",
        label: "Night Allowance Start Time",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "",
        required: false,
        type: "time",
        name: "nightAllowanceEnd",
        label: "Night Allowance End Time",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "",
        required: false,
        type: "time",
        name: "earlyStartAllowanceStart",
        label: "Early Start Allowance Start Time",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "",
        required: false,
        type: "time",
        name: "earlyStartAllowanceEnd",
        label: "Early Start Allowance End Time",
      },
      {
        noShowConfig: true,
        gridSize: 12,
        name: "noShowConfig",
        required: true,
        label: "",
      },
      {
        radio: true,
        gridSize: 4,
        name: "guestSignatureRequired",
        label: "Guest Signature Required",
        required: false,
        values: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
      },
      {
        radio: true,
        gridSize: 4,
        name: "sealSignatureEnabled",
        label: "Enable Seal & Signature",
        required: false,
        values: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
      },
      {
        radio: true,
        gridSize: 4,
        name: "sealSignatureOverride",
        label: "Do you want override",
        required: false,
        showWhenChecked: "sealSignatureEnabled",
        values: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
      },
      {
        sealSignatureUpload: true,
        uploadType: "seal",
        gridSize: 6,
        name: "sealSignatureSeal",
        label: "Company Override Seal",
        showWhenChecked: "sealSignatureOverride",
      },
      {
        sealSignatureUpload: true,
        uploadType: "signature",
        gridSize: 6,
        name: "sealSignatureSignature",
        label: "Company Override Signature",
        showWhenChecked: "sealSignatureOverride",
      },
      {
        radio: true,
        gridSize: 4,
        name: "costCentreVisible",
        label: "Cost Centre Visible",
        required: false,
        values: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
      },
      {
        radio: true,
        gridSize: 4,
        name: "costCentreMandatory",
        label: "Cost Centre Mandatory",
        required: false,
        showWhenChecked: "costCentreVisible",
        values: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: "Enter Cost Centre",
        required: false,
        type: "text",
        name: "costCentreLabel",
        label: "Cost Centre",
        showWhenChecked: "costCentreVisible",
      },

      {
        radio: true,
        gridSize: 12,
        name: "smsNotificationsEnabled",
        label: "SMS Notification Settings",
        required: false,
        values: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
      },
      {
        name: "bookingConfirmation",
        checkbox: true,
        gridSize: 4,
        required: false,
        showWhenChecked: "smsNotificationsEnabled",
        subItems: [
          {
            name: "bookingConfirmation",
            checkboxLablel: "Booking Confirmation",
          },
        ],
      },
      {
        name: "vehicleAssignment",
        checkbox: true,
        gridSize: 4,
        required: false,
        showWhenChecked: "smsNotificationsEnabled",
        subItems: [
          { name: "vehicleAssignment", checkboxLablel: "Vehicle Assignment" },
        ],
      },
      {
        name: "vehicleReassignment",
        checkbox: true,
        gridSize: 4,
        required: false,
        showWhenChecked: "smsNotificationsEnabled",
        subItems: [
          {
            name: "vehicleReassignment",
            checkboxLablel: "Vehicle Reassignment",
          },
        ],
      },
      {
        name: "tripStart",
        checkbox: true,
        gridSize: 4,
        required: false,
        showWhenChecked: "smsNotificationsEnabled",
        subItems: [{ name: "tripStart", checkboxLablel: "Trip Start" }],
      },
      {
        name: "tripCompletion",
        checkbox: true,
        gridSize: 4,
        required: false,
        showWhenChecked: "smsNotificationsEnabled",
        subItems: [
          { name: "tripCompletion", checkboxLablel: "Trip Completion" },
        ],
      },
      {
        name: "tripCancellation",
        checkbox: true,
        gridSize: 4,
        required: false,
        showWhenChecked: "smsNotificationsEnabled",
        subItems: [
          { name: "tripCancellation", checkboxLablel: "Trip Cancellation" },
        ],
      },
      {
        name: "tripReschedule",
        checkbox: true,
        gridSize: 4,
        required: false,
        showWhenChecked: "smsNotificationsEnabled",
        subItems: [
          { name: "tripReschedule", checkboxLablel: "Trip Reschedule" },
        ],
      },
      {
        name: "paymentLink",
        checkbox: true,
        gridSize: 4,
        required: false,
        showWhenChecked: "smsNotificationsEnabled",
        subItems: [{ name: "paymentLink", checkboxLablel: "Payment Link" }],
      },
      {
        name: "otp",
        checkbox: true,
        gridSize: 4,
        required: false,
        showWhenChecked: "smsNotificationsEnabled",
        subItems: [{ name: "otp", checkboxLablel: "OTP" }],
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],

    "Employee Registration Settings": [
      {
        radio: true,
        gridSize: 4,
        name: "selfRegistrationAllowed",
        label: "Self Registration Allowed",
        values: [
          {
            value: true,
            label: "Yes",
          },
          {
            value: false,
            label: "No",
          },
        ],
      },
      {
        radio: true,
        gridSize: 4,
        name: "approvalRequired",
        label: "Approval Required",
        values: [
          {
            value: true,
            label: "Yes",
          },
          {
            value: false,
            label: "No",
          },
        ],
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],

    "Office Details": [
      {
        cityOption: true,
        gridSize: 12,
        required: true,
        // label: "Choose Cities",
        placeholder: "Choose a City",
        menuOptions: cityOption || [],
        checkboxOptions: [
          {
            id: "1",
            name: "sez",
            checkboxLablel: "SEZ( Special Economic Zone )",
          },
        ],
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
    // "Billing Details": [
    //   {
    //     name: "billingDetails",
    //     checkbox: true,
    //     required: true,
    //     gridSize: 12,
    //     subItems: [
    //       {
    //         id: "1",
    //         name: "billToCreditCard",
    //         checkboxLablel: "Bill to credit card",
    //       },
    //       {
    //         id: "2",
    //         name: "billToCompany",
    //         checkboxLablel: "Bill to company",
    //       },
    //     ],
    "Billing Details": [
      {
        name: "billingDetails",
        checkbox: true,
        required: false,
        gridSize: 12,
        subItems: [
          {
            id: "1",
            name: "billToSelf",
            checkboxLablel: billToSelfLabel?.trim()
              ? billToSelfLabel
              : "Bill To Self",
          },
          {
            id: "2",
            name: "billToCompany",
            checkboxLablel: billToCompanyLabel?.trim()
              ? billToCompanyLabel
              : "Bill To Company",
          },
        ],
      },

      {
        options: true,
        required: true,
        gridSize: 6,
        placeholder: "Choose your Bill Submission Cycle",
        type: "text",
        name: "billingCycle",
        label: "Bill Submission Cycle",
        menuOptions: [
          {
            label: "Weekly",
            value: "Weekly",
          },
          {
            label: "Monthly",
            value: "Monthly",
          },
          {
            label: "Fortnightly",
            value: "Fortnightly",
          },
        ],
      },
      {
        options: true,
        required: true,
        gridSize: 6,
        placeholder: "Choose your Billing Type",
        type: "text",
        name: "invoiceType",
        label: "Billing Type",
        menuOptions: [
          {
            label: "Consolidated",
            value: "Consolidated",
          },
          {
            label: "Individual",
            value: "Individual",
          },
        ],
      },
      {
        options: true,
        required: true,
        gridSize: 6,
        placeholder: "Choose Duty Configuration",
        type: "text",
        name: "config",
        label: "Duty Configuration",
        menuOptions: [
          {
            value: "Point-To-Point",
            label: "Is Point to Point",
          },
          {
            value: "Point-To-Garage",
            label: "Is Point to Point with Fixed Garage Run",
          },
          {
            value: "Garage-To-Garage",
            label: "Is Garage to Garage",
          },
        ],
      },
      {
        garageRateConfig: true,
        gridSize: 12,
        name: "garageRateConfig",
        label: "",
        conditionalField: "config",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Fixed garage run",
        rupee: true,
        type: "number",
        name: "configRate",
        label: "Fixed garage run",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Choose Approve or Dispute Duration",
        required: false,
        type: "number",
        name: "approvalDuration",
        label: "Approve or Dispute Duration (in hr)",
      },
      {
        fileUpload: true,
        required: true,
        gridSize: 6,
        name: "InsuranceFile",
        label: "Upload Agreement",
        defaultValue: values?.Contracts?.[0]?.agreement,
      },

      {
        multifileUpload: true,
        required: false,
        gridSize: 6,
        name: "DocumentFile",
        label: "Upload Documents",
        defaultValue: values?.docs,
      },
      {
        radio: true,
        gridSize: 6,
        name: "paymentTriggerMode",
        label: "Payment Trigger Mode",
        showWhenChecked: "billToSelf",
        required: true,
        values: [
          {
            value: "afterTripEnd",
            label: "After Trip End",
          },
          {
            value: "afterInvoice",
            label: "After Invoice",
          },
        ],
      },
    ],
    "Default Tax Configuration": [
      {
        options: true,
        required: false,
        gridSize: 4,
        placeholder: "Select IGST",
        type: "text",
        name: "defaultIgstTaxId",
        label: "Default IGST",
        menuOptions: taxOptions,
      },
      {
        options: true,
        required: false,
        gridSize: 4,
        placeholder: "Select CGST",
        type: "text",
        name: "defaultCgstTaxId",
        label: "Default CGST",
        menuOptions: taxOptions,
      },
      {
        options: true,
        required: false,
        gridSize: 4,
        placeholder: "Select SGST",
        type: "text",
        name: "defaultSgstTaxId",
        label: "Default SGST",
        menuOptions: taxOptions,
      },
    ],
  };
};

// GSTFormData is now a function to support multiple admin/finance members
export const GSTFormData = (adminCount = 1, financeCount = 1) => {
  const adminFields = [];
  for (let i = 0; i < adminCount; i++) {
    adminFields.push(
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Admin Name",
        required: true,
        type: "text",
        name: `adminName_${i}`,
        label: `Name`,
        star: "*",
        memberIndex: i,
        memberType: "admin",
      },
      {
        textField: true,
        gridSize: 6,
        required: true,
        placeholder: "Enter Admin Email ID",
        type: "text",
        name: `adminEmail_${i}`,
        label: `Email ID`,
        star: "*",
        memberIndex: i,
        memberType: "admin",
      },
      {
        textField: true,
        gridSize: 6,
        required: true,
        placeholder: "Enter Admin Phone Number",
        type: "number",
        countrycode: true,
        name: `adminPhone_${i}`,
        label: `Phone No.`,
        star: "*",
        memberIndex: i,
        memberType: "admin",
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
        memberIndex: i,
        memberType: "admin",
      },
    );
  }

  const financeFields = [];
  for (let i = 0; i < financeCount; i++) {
    financeFields.push(
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Finance Team Name",
        required: false,
        type: "text",
        name: `financeName_${i}`,
        label: `Name`,
        star: "*",
        memberIndex: i,
        memberType: "finance",
      },
      {
        textField: true,
        gridSize: 6,
        placeholder: "Enter Finance Team Email ID",
        required: false,
        type: "email",
        name: `financeEmail_${i}`,
        label: `Email ID`,
        memberIndex: i,
        memberType: "finance",
      },
      {
        textField: true,
        gridSize: 6,
        countrycode: true,
        placeholder: "Enter Finance Team Phone Number",
        required: false,
        type: "number",
        name: `financePhone_${i}`,
        label: `Phone No.`,
        memberIndex: i,
        memberType: "finance",
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
        memberIndex: i,
        memberType: "finance",
      },
    );
  }

  return {
    "Admin Team Details": adminFields,
    "Finance Team Details": financeFields,
  };
};

export const companyFilterData = (cityOption) => [
  {
    id: 1,
    primaryText: "Location",
    subItems: cityOption,
  },
  {
    id: 2,
    primaryText: "Status",
    subItems: [
      { value: "Active", key: "Status" },
      { value: "InActive", key: "Status" },
    ],
  },
];
